// extracted by css-extract-rspack-plugin
export default {"ganttColumnsDropdown__box":"ganttColumnsDropdown__box-RkYMrK","ganttColumnsDropdownBox":"ganttColumnsDropdown__box-RkYMrK"};